export default __webpack_public_path__ + "static/media/ticket.4c2743cd.svg";